// Network selection: REACT_APP_NETWORK=mainnet (BSC 56, npm run build:mainnet), testnet (default, BSC testnet 97) or fork (local anvil, 97).
import abis from './abis.json';
import forkDeployments from './deployments.fork.json';
import testnetDeployments from './deployments.testnet.json';
import mainnetDeployments from './deployments.mainnet.json'; // placeholder until the mainnet deploy; build:mainnet refuses to build from it

const NETWORKS = {
  mainnet: {
    key: 'mainnet',
    label: 'BNB Smart Chain',
    chainName: 'BNB Chain',
    currency: 'BNB',
    chainId: 56,
    rpc: process.env.REACT_APP_RPC_URL || 'https://bsc-rpc.publicnode.com',
    explorer: 'https://bscscan.com',
    logChunk: 45000,
    d: mainnetDeployments,
  },
  testnet: {
    key: 'testnet',
    label: 'BSC Testnet',
    chainName: 'BNB Chain testnet', // used in copy (agent prompt, connect dialog)
    currency: 'tBNB',
    chainId: 97,
    rpc: process.env.REACT_APP_RPC_URL || 'https://bsc-testnet-rpc.publicnode.com',
    explorer: 'https://testnet.bscscan.com',
    logChunk: 45000, // public RPCs cap eth_getLogs ranges
    d: testnetDeployments,
  },
  fork: {
    key: 'fork',
    label: 'Local fork (anvil)',
    chainName: 'the local test chain',
    currency: 'BNB',
    chainId: 97,
    rpc: process.env.REACT_APP_RPC_URL || 'http://127.0.0.1:8546',
    explorer: null,
    logChunk: 0, // 0 = single query
    d: forkDeployments,
  },
};

export const NET = NETWORKS[process.env.REACT_APP_NETWORK || 'testnet'] || NETWORKS.testnet;
export const ADDR = NET.d;
export const ABI = {
  ORE: abis.ORE,
  Ships: abis.Ships,
  Genesis: abis.Genesis,
  Fleet: abis.Fleet,
  Shipyard: abis.Shipyard,
  Marketplace: abis.Marketplace,
  RandomnessHub: abis.RandomnessHub,
  EmissionReserve: abis.EmissionReserve,
  AgentIDRegistry: abis.MockAgentIDRegistry, // only handleOf() is used on mainnet; register() exists on the testnet mock only
};
export const CHAIN_HEX = '0x' + NET.chainId.toString(16);
export const explorerAddr = (a) => (NET.explorer ? `${NET.explorer}/address/${a}` : null);
export const explorerTx = (h) => (NET.explorer ? `${NET.explorer}/tx/${h}` : null);
